import { Card, Box, Button } from '@mui/material';
import RxOutcome from './RxOutcome';
import Trails from './Trails';
import { ICLFitting } from '../../../../../@types/clFitting.type';
import { ITrail } from '../../../../../@types/trail.type';
import { IClinicalRecordSchema } from '../../../../../@types/clinicalRecord.type';
import { useCallback, useRef, useState } from 'react';

type Props = {
  clinicalRecordId: number;
  tab: (type: string) => void;
  showCLForm: boolean;
  clFitting: ICLFitting;
  trails: ITrail[];
  getCLFittingRecords: (clFittingId: number, clinicalId: number) => void;
  getTrailsRecords: (clinicalId: number) => void;
  onUpdate?: () => Promise<any> | void;
  selectedRow: number;
  clinicalRecords: IClinicalRecordSchema[];
};

const CLFitting = ({
  clinicalRecordId,
  tab,
  showCLForm,
  clFitting,
  trails,
  getCLFittingRecords,
  getTrailsRecords,
  onUpdate,
  selectedRow,
  clinicalRecords,
}: Props) => {
  const [semiFinal, setSemiFinal] = useState({});
  const [openNewTrailForm, setOpenNewTrailForm] = useState(false);
  const trailsRef = useRef<HTMLDivElement | null>(null);

  /**
   * "To Trial" used to navigate to /diary, the same place as "Book For Teach"
   * (client bug 42). The trial screen is the Trails section on this page, so it
   * scrolls there and opens a new trial instead.
   */
  const handleToTrail = useCallback(() => {
    trailsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setOpenNewTrailForm(true);
  }, []);

  const handleNewTrailFormHandled = useCallback(
    () => setOpenNewTrailForm(false),
    [],
  );

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setSemiFinal((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return (
    <Box
      sx={{
        margin: '2% 5%',
      }}
    >
      <Box mb={10} ref={trailsRef}>
        <Trails
          clinicalRecordId={clinicalRecordId}
          trails={trails}
          getTrailsRecords={getTrailsRecords}
          selectedRow={selectedRow}
          clinicalRecords={clinicalRecords}
          handleChange={handleChange}
          openNewTrailForm={openNewTrailForm}
          onNewTrailFormHandled={handleNewTrailFormHandled}
        />
      </Box>
      <Box mb={15}>
        <RxOutcome
          clinicalRecordId={clinicalRecordId}
          tab={tab}
          clFitting={clFitting}
          showCLForm={showCLForm}
          getCLFittingRecords={getCLFittingRecords}
          onUpdate={onUpdate}
          semiFinal={semiFinal}
          onToTrail={handleToTrail}
        />
      </Box>
    </Box>
  );
};

export default CLFitting;
